"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
import _ from "lodash";
import ShopPlatforms from "@/views/virtualdesktopItems/components/dialog-forms/ShopPlatforms.vue";
import Question from "@/components/Question.vue";
import vueQr from "vue-qr";
import { AccountSessionMixins } from "@/service/account-session";
export class DeleteVdForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.platform = "";
    this.site = "";
    this.shop_name = "";
    this.custom_website = "";
    this.register_region = "";
    this.ua_info = "";
    this.ratio_info = i18n.t(
      "create_safe_dialog.form.ratio_info_tip"
    );
    this.lang = "";
    this.cookie_sync = i18n.t(
      "create_safe_dialog.form.cookie_sync_info"
    );
    this.shop_lock = false;
    this.mode = "custom";
    this.resolution_mode = "AUTO";
    this.cookie_mode = {
      mode: "SHOP_COOKIE_AUTOSYNC"
    };
    this.ebusiness_platform_guid = "";
    this.all_ua = null;
    this.os = null;
    this.useragent_package = null;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true
    }
  ])
], DeleteVdForm.prototype, "platform", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("create_safe_dialog.form.site_tips"),
      trigger: "blur"
    }
  ])
], DeleteVdForm.prototype, "site", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("create_safe_dialog.form.name_tips"),
      trigger: "blur"
    }
  ])
], DeleteVdForm.prototype, "shop_name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("create_safe_dialog.form.custom_website_tip")
    }
  ])
], DeleteVdForm.prototype, "custom_website", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("create_safe_dialog.form.register_region_tip")
    }
  ])
], DeleteVdForm.prototype, "register_region", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("create_safe_dialog.form.site_tips"),
      trigger: "blur"
    }
  ])
], DeleteVdForm.prototype, "ebusiness_platform_guid", 2);
let NewCreateSafeEnvDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.dialogLoading = false;
    this.show_guide = 1;
    this.controller = new DeleteVdForm();
    this.lang_lists = [];
    this.platform_list = [];
    this.business_list = [];
    this.country_list = [];
    this.selectedIds = {
      method: "create"
    };
    this.shop_id = "";
    this.shopInfo = {};
    this.recommand_list = [];
    this.recommand_choose = {};
    this.paymentWay = "";
    this.payment_data = {};
    this.showModal = false;
    this.orderTimer = null;
    this.orderTimeLeft = 1800;
    this.qrCodeTimer = null;
    this.qrCodeTimeLeft = 120;
    this.orderInfo = {};
  }
  open() {
    return __async(this, null, function* () {
      try {
        yield this.getInfos();
        this.dialog.visible = true;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    this.reset();
    this.dialog.visible = false;
    this.$emit("refresh");
  }
  reset() {
    this.show_guide = 1;
    this.controller = new DeleteVdForm();
    this.showModal = false;
    clearInterval(this.orderTimer);
    clearInterval(this.qrCodeTimer);
  }
  getInfos() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        let system_response = yield API.get(`api://base.auth/api/v8/payment/virtualdesktop/region/common`);
        this.controller.os = {
          android: system_response.data.os.android[0],
          linux: system_response.data.os.linux[0],
          mac: system_response.data.os.mac[0],
          unify: null,
          windows: system_response.data.os.windows[0]
        };
        this.controller.useragent_package = {
          androidUa: system_response.data.useragent[system_response.data.os.android[0]][0],
          linuxUa: system_response.data.useragent[system_response.data.os.linux[0]][0],
          macUa: system_response.data.useragent[system_response.data.os.mac[0]][0],
          unifyUa: null,
          winUa: system_response.data.useragent[system_response.data.os.windows[0]][0]
        };
        let lang_response = yield API.get(`api://base.auth/api/v7/browser_ui_languages`);
        this.lang_lists = lang_response.data.datas;
        this.controller.lang = (_b = (_a = this.lang_lists.find((item) => item.abbreviation === "zh-CN")) == null ? void 0 : _a.abbreviation) != null ? _b : "";
        let platform_response = yield API.get(
          "api://base.auth.pro/v1/fast-shop-ebusiness"
        );
        this.platform_list = platform_response.data.datas;
        this.platform_list.push({
          id: "more",
          name: i18n.t("create_safe_dialog.more_platform")
        });
        this.platform_list.push({
          id: "custom",
          name: i18n.t("create_safe_dialog.custom_platform")
        });
        this.controller.platform = this.platform_list[0].id;
        let business_response = yield API.get(`api://base.auth.pro/v1/fast-shop-ebusiness/${this.controller.platform}/platform`);
        this.business_list = business_response.data.datas;
        let _default_business = _.find(this.business_list, { "defaultsSelect": true });
        if (_default_business) {
          this.controller.ebusiness_platform_guid = _default_business.guid;
        } else {
          this.controller.ebusiness_platform_guid = this.business_list[0].guid;
        }
        let country_response = yield API.get(`api://base.auth.pro/v1/fast-shop-country`);
        this.country_list = country_response.data.datas;
        this.controller.register_region = this.country_list[0].guid;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changePlatform() {
    return __async(this, null, function* () {
      try {
        this._shopForm._form.clearValidate();
        if (this.controller.platform === "more") {
          this.controller.ebusiness_platform_guid = "";
          yield this._shopPlatform.open();
        }
        if (this.controller.platform !== "more" && this.controller.platform !== "custom") {
          let business_response = yield API.get(`api://base.auth.pro/v1/fast-shop-ebusiness/${this.controller.platform}/platform`);
          this.business_list = business_response.data.datas;
          let _default_business = _.find(this.business_list, { "defaultsSelect": true });
          if (_default_business) {
            this.controller.ebusiness_platform_guid = _default_business.guid;
          } else {
            this.controller.ebusiness_platform_guid = this.business_list[0].guid;
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  select(item) {
    return __async(this, null, function* () {
      try {
        let _platform_id = item.plateinfo.guid;
        let result = _.find(this.platform_list, { id: _platform_id });
        if (result) {
          this.controller.platform = _platform_id;
          let business_response = yield API.get(`api://base.auth.pro/v1/fast-shop-ebusiness/${this.controller.platform}/platform`);
          this.business_list = business_response.data.datas;
        }
        this.controller.site = item.webinfo.name;
        this.controller.ebusiness_platform_guid = item.webinfo.guid;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  createShop() {
    return __async(this, null, function* () {
      try {
        this.dialogLoading = true;
        let new_env_submit_data = __spreadValues(__spreadProps(__spreadValues({
          "model": "shop.custom"
        }, (() => {
          if (this.controller.platform !== "custom") {
            return {
              "ebusinessPlatform": {
                "model": "shop.platform",
                "id": this.controller.ebusiness_platform_guid
              }
            };
          } else {
            return {
              "ebusinessPlatform": {
                "model": "shop.custom.platform",
                "url": this.controller.custom_website
              }
            };
          }
        })()), {
          "name": this.controller.shop_name,
          "cookieSync": this.controller.cookie_mode.mode,
          "resolution": {
            "mode": this.controller.resolution_mode,
            "screen": null
          },
          "uiLanguage": this.controller.lang,
          "shopLock": {
            "lock": this.controller.shop_lock,
            "lockNum": null
          }
        }), (() => {
          return {
            "osUserAgent": {
              "model": "shop.os.ua",
              "windows": {
                "osCode": this.controller.os.windows,
                "userAgent": this.controller.useragent_package.winUa
              },
              "mac": {
                "osCode": this.controller.os.mac,
                "userAgent": this.controller.useragent_package.macUa
              },
              "android": {
                "osCode": this.controller.os.android,
                "userAgent": this.controller.useragent_package.androidUa
              },
              "linux": {
                "osCode": this.controller.os.linux,
                "userAgent": this.controller.useragent_package.linuxUa
              }
            }
          };
        })());
        console.log(new_env_submit_data);
        let response = yield API.post(`api://base.auth.pro/v1/shops`, new_env_submit_data);
        this.$message.success(this.$t("create_safe_dialog.create_shop_success_tip"));
        this.shop_id = response.data.oldId;
        yield this.getRecommend();
        this.dialogLoading = false;
        this.show_guide = 2;
      } catch (error) {
        this.dialogLoading = false;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getRecommend() {
    return __async(this, null, function* () {
      var _a;
      try {
        let recommand_response = yield API.get(`api://base.auth/api/v8/noviceguide/recomment/ipregion`, {
          params: {
            "country_id": this.controller.register_region,
            "shop_id": this.shop_id
          }
        });
        this.shopInfo = recommand_response.data.shop;
        this.recommand_list = recommand_response.data.datas;
        this.recommand_choose = (_a = this.recommand_list[0]) != null ? _a : {};
        if (this.recommand_choose.payments) {
          this.paymentWay = this.recommand_choose.payments.some((item) => item.payment === "alipay") ? "alipay" : this.recommand_choose.payments[0].payment;
        }
      } catch (error) {
        this.dialogLoading = false;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goToBuy() {
    return __async(this, null, function* () {
      this.dialogLoading = true;
      let shop_id = this.shop_id;
      this.$router.push({
        name: "payment",
        query: { style: "create" },
        params: {
          shop_id
        }
      });
      this.dialogLoading = true;
    });
  }
  createOrder() {
    return __async(this, null, function* () {
      try {
        this.showModal = false;
        this.dialogLoading = true;
        this.payment_data = {
          callback: "https://app.kuajingvs.com/paymentcomplete",
          discounts: [],
          order_source: "NOVICE_GUIDE",
          pay_type: this.paymentWay,
          pay_vdcards: [],
          product: {
            auto_renew: false,
            auto_resolution: true,
            auto_timezone: false,
            browser_guid: this.recommand_choose.product.browserGuid,
            country_guid: this.recommand_choose.product.countryGuid,
            goods_spec_guid: this.recommand_choose.product.goodsSpecGuid,
            language_guid: this.recommand_choose.product.languageGuid,
            os: this.recommand_choose.os,
            region_guid: this.recommand_choose.guid,
            screen: "",
            timezone_guid: this.recommand_choose.product.timezoneGuid,
            unify_os: this.recommand_choose.product.unifyOs,
            userAgent: this.recommand_choose.user_agent
          },
          quantity: 1,
          shop_id: this.shop_id,
          user_input: {}
        };
        let response = yield API.post(
          `api://base.auth/api/v7/orders/vd_new/pay`,
          this.payment_data
        );
        this.orderInfo = response.data.order;
        this.setOrderTimer();
        this.setQrCodeTimer();
        this.orderInfo.url = response.data.url;
        this.orderInfo.logoUrl = this.payment_data.pay_type === "alipay" ? require("../../../../assets/img/pay_zfb_logo.png") : require("../../../../assets/img/pay_wx_logo.png");
        this.dialogLoading = false;
        this.show_guide = 3;
      } catch (error) {
        this.dialogLoading = false;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  cancelOrder() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v7/orders/${this.orderInfo.id}/cancel`);
      } catch (error) {
        this.dialogLoading = false;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        clearInterval(this.orderTimer);
        clearInterval(this.qrCodeTimer);
      }
    });
  }
  setOrderTimer() {
    new Promise((resolve, reject) => {
      this.orderTimeLeft = 1800;
      this.orderTimer = setInterval(() => __async(this, null, function* () {
        this.orderTimeLeft -= 1;
        if (this.orderTimeLeft < 0) {
          yield this.cancelOrder();
          resolve(this);
          clearInterval(this.qrCodeTimer);
          this.showModal = true;
          clearInterval(this.orderTimer);
        }
      }), 1e3);
    });
  }
  setQrCodeTimer() {
    return __async(this, null, function* () {
      try {
        new Promise((resolve, reject) => {
          this.qrCodeTimeLeft = 120;
          this.qrCodeTimer = setInterval(() => __async(this, null, function* () {
            this.qrCodeTimeLeft -= 1;
            if (this.qrCodeTimeLeft < 0) {
              clearInterval(this.qrCodeTimer);
              resolve(this);
              this.showModal = true;
            }
            let wait_response = yield API.get(
              `api://base.auth/api/v7/orders/${this.orderInfo.id}/check_pay_status`
            );
            if (wait_response.data.order_has_paid) {
              let info = wait_response.data.additional_data.buy_info;
              localStorage.setItem("recommand", info);
              clearInterval(this.qrCodeTimer);
              resolve(this);
              this.close();
            }
          }), 1e3);
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
        yield this.cancelOrder();
        this.showModal = true;
      }
    });
  }
  refreshQrCode() {
    return __async(this, null, function* () {
      if (this.orderTimeLeft < 0) {
        yield this.cancelOrder();
        yield this.createOrder();
      } else {
        this.showModal = false;
        this.setQrCodeTimer();
      }
    });
  }
  goToPrevious(step) {
    return __async(this, null, function* () {
      if (step === 1) {
        this.controller = new DeleteVdForm();
        yield this.getInfos();
      } else if (step === 2) {
        yield this.cancelOrder();
        yield this.getRecommend();
      }
      this.show_guide = step;
    });
  }
  contactCustomerService() {
    window.open("https://www.kuajingvs.com/contact", "_blank");
  }
};
__decorateClass([
  Ref("shopForm")
], NewCreateSafeEnvDialog.prototype, "_shopForm", 2);
__decorateClass([
  Ref("shop-platform")
], NewCreateSafeEnvDialog.prototype, "_shopPlatform", 2);
NewCreateSafeEnvDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog,
      ShopPlatforms,
      Question,
      vueQr
    }
  })
], NewCreateSafeEnvDialog);
export {
  NewCreateSafeEnvDialog as default
};
